<template>
  <GwMenu
    class="h-100 d-flex"
    trigger="hover"
    placement="bottom"
    :flOptions="{ offset: 0, padding: 0 }"
  >
    <template #opener>
      <router-link
        class="h-100"
        :class="links_menu[1].pathName === $route.name ? 'router-link-active' : ''"
        :to="{ name: links_menu[1].pathName, query: links_menu[1].query || {} }"
        data-tst="study_menu_link_main"
      >
        <NavCard
          :item="links_menu[1]"
          class="navcard_menu navcard_menu-trigger navcard_router-link"
          :style="'--clr-text:var(--clr-grey-2); --padding: 0 1rem;'"
          :hasSub="false"
          :class="{ 'navcard_router-link_active': $route.name === 'Coaching' }"
        />
      </router-link>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu"
        style="padding: 0"
        @click="methods.toggleOpen(false)"
      >
        <div class="app-group-menu">
          <router-link
            v-for="item in links_study.filter(item => item.pathName !== 'NotExistent')"
            :key="item.id"
            :to="{ name: item.pathName, query: item.query || {} }"
            :class="{ 'no-events': item.disabled }"
            :data-tst="`study_menu_link_${item?.data_tst}`"
          >
            <NavCard
              :hasIcon="false"
              :hasTitleIcon="true"
              :class="{ navcard_active: item.active }"
              :item="item"
              class="router-link-active-ignore navcard_menu navcard_reversed_l text-nowrap navcard_router-link"
              :style="item.style"
              :hasTag="item.pathName === 'StudyPlansDashboard'"
              @touchstart="
                () => {
                  if (item.fn) {
                    item.fn()
                  }
                }
              "
              @mousedown="
                () => {
                  if (item.fn) {
                    item.fn()
                  }
                }
              "
            />
          </router-link>
        </div>
        <div
          v-if="!$i18n.g1"
          class="bt-grey w-100 d-flex"
          style="grid-column: 1/-1"
        >
          <LinkGuide
            class="ml-auto px-4 py-2"
            :link="links_url_links.solution_browser.url"
            :text="links_url_links.solution_browser.text"
            @click.stop
          />
        </div>
      </div>
    </template>
  </GwMenu>
</template>

<script>
import LinkGuide from '@/components/AppBar/LinkGuide'
import GwMenu from '@/components/lib/GwMenu'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'StudyMenu',
  components: {
    LinkGuide,
    GwMenu,
  },
  mixins: [links_mix],
}
</script>
